//import loginService from './loginService';
import Vue              from 'vue';
import skpLoginService  from './skpLoginService';
import skpMenuService   from './skpMenuService';
import skpCommonService from './skpCommonService';
import cacheService     from './cacheService';

export default {
    async directLogin(loginId, loginPwd, loginSystem, loginType, loadMenuKind) {
        try {
            const loginResponse = await skpLoginService.directLogin(loginId, loginPwd, loginSystem, loginType, loadMenuKind);
            return loginResponse;

        } catch (err) {
            Vue.$log.error(err);
        }
    },
    async loginEpTray(epTrayKey) {
        try {
            const loginResponse = await skpLoginService.loginEpTray(epTrayKey);
            return loginResponse;

        } catch (err) {
            Vue.$log.error(err);
        }
    },
    async changeSubsidiary(topRhqCd, topRhqNm, topSubsidiaryCd, topSubsidiaryNm, loginSystem) {
        try {
            const loginResponse = await skpLoginService.changeSubsidiary(topRhqCd, topRhqNm, topSubsidiaryCd, topSubsidiaryNm, loginSystem);
            return loginResponse;

        } catch (err) {
            Vue.$log.error(err);
        }
    },
    async setLoginFromOtherSystem(res) {
        try {
            const response = await skpLoginService.setLoginFromOtherSystem(res);
            return response;

        } catch (err) {
            Vue.$log.error(err);
        }
    },
    async setLoginFromOtherSystemCSP(res) {
        try {
            const response = await skpLoginService.setLoginFromOtherSystemCSP(res);
            return response;

        } catch (err) {
            Vue.$log.error(err);
        }
    },
    async refreshToken() {
        try {
            return await skpLoginService.refreshToken();

        } catch (err) {
            Vue.$log.error(err);
        }
    },
    async getComboList(comboVal, comboCd, userCompanyCode) {
        try {
            const codeResponse = await skpCommonService.getComboList(comboVal, comboCd, userCompanyCode);
            return codeResponse;

        } catch (err) {
            Vue.$log.error(err);
        }
    },
    async getCommonCodeList(comboCd, stat, lang) {
        try {
            const codeResponse = await skpCommonService.getCommonCodeList(comboCd, stat, lang);
            return codeResponse;

        } catch (err) {
            Vue.$log.error(err);
        }
    },
    async getCommonHardCodeList(comboCd) {
        try {
            const codeResponse = await skpCommonService.getCommonHardCodeList(comboCd);
            return codeResponse;

        } catch (err) {
            Vue.$log.error(err);
        }
    },
    logout() {
        skpLoginService.logout();
    },
    async getMenus(forceRemote = false) {
        return skpMenuService.getMenus(forceRemote);
    },
    clearCache() {
        cacheService.clearCache();
    },
};



// WEBPACK FOOTER //
// ./src/service/index.js